import type { IPolicyReinstatement } from '@/shared/api/models.bff';
import { parseNum } from './Policy';

//
export interface IReinstatement {
  paymentAsOfReIssueDate: number;
  paymentAsOfOrgIssueDate: number;
  termDate: string;
  pacPremium: string;
  eligible: boolean;
  eligibleDod?: boolean; // 'yes' or 'no'
  redirectUrl: string;
  state: string;
}

export const mapReinstatementResponse = ({
  paymentAsOfReIssueDate,
  paymentAsOfOrgIssueDate,
  termDate,
  pacPremium,
  eligible,
  eligibleDod,
  redirectUrl,
  state,
}: IPolicyReinstatement): IReinstatement => {
  const mappedBeneficiary = {
    paymentAsOfReIssueDate: parseNum(paymentAsOfReIssueDate),
    paymentAsOfOrgIssueDate: parseNum(paymentAsOfOrgIssueDate),
    termDate,
    pacPremium,
    eligible: Boolean(eligible),
    eligibleDod: Boolean(eligibleDod),
    redirectUrl: redirectUrl || '',
    state: state || '',
  };
  return mappedBeneficiary;
};
